import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { SET_CURRENT_CONVERSATION } from "../../reducers/ChatReducer";
import { useChatContext } from "../../providers/ChatProvider";
import { useBreakpoints } from "../../providers/BreakpointsProvider";
import ChatContent from "../../components/chat/chat-content";
import ChatSidebar from "../../components/chat/ChatSidebar";

const ChatConversation = () => {
  const { userId } = useParams();

  const { chatDispatch, conversations } = useChatContext();

  const { breakpoints } = useBreakpoints();
  useEffect(() => {
    chatDispatch({
      type: SET_CURRENT_CONVERSATION,
      payload: {
        userId,
      },
    });
  }, [userId, conversations]);

  return (
    <>
      {breakpoints.up("sm") && <ChatSidebar />}
      <ChatContent />
    </>
  );
};

export default ChatConversation;
